<app-angular-loader></app-angular-loader>
<div fxLayout="row" style="min-height: 100%;" [ngClass]="{'fixed': this.sideNavOpened}" class="{{themeClass}}">
    <div
      id="mainmnu"
      class="dark-theme"
      style="background-color: #424242;"
      [ngClass]="{'fixed': this.sideNavOpened}"
      fxLayout="column"
      *ngIf="auth.user.level != 2"
    >
        <div class="dark-theme" fxLayout="column">
            <h1 id="s_sira" style="display: flex; flex-direction: row">
              SG
              <div class="logo">
                <img
                  *ngIf="appService.logo_dark > ''"
                  [src]="appService.logo_dark" height="40px" />
              </div>
              <mat-icon (click)="toggleSideNav()" svgIcon="pin" id="pin_icon"></mat-icon>
            </h1>
            <div class="cmmenu" fxLayout="column">
                <mat-list class="dark-theme">
                    <mat-list-item class="dark-theme">
                        <a routerLink="/main" (click)="toggleSideNav()" *mqIf="'(max-width: 640px)'" fxLayout="row"><mat-icon>home</mat-icon><span>Inicio</span></a>
                        <a routerLink="/main" (click)="hideSideNav()" *mqIf="'(min-width: 640px)'" fxLayout="row"><mat-icon>home</mat-icon><span>Inicio</span></a>
                    </mat-list-item>
                    <mat-list-item class="dark-theme">
                        <a routerLink="/animals" (click)="toggleSideNav()" *mqIf="'(max-width: 640px)'" fxLayout="row"><mat-icon>pets</mat-icon><span>Animales</span></a>
                        <a routerLink="/animals" (click)="hideSideNav()" *mqIf="'(min-width: 640px)'" fxLayout="row"><mat-icon>pets</mat-icon><span>Animales</span></a>
                    </mat-list-item>
                    <mat-list-item class="dark-theme">
                        <a routerLink="/crias" (click)="toggleSideNav()" *mqIf="'(max-width: 640px)'" fxLayout="row"><mat-icon svgIcon="crias" class="dark-theme">crias</mat-icon><span>Crías</span></a>
                        <a routerLink="/crias" (click)="hideSideNav()" *mqIf="'(min-width: 640px)'" fxLayout="row"><mat-icon svgIcon="crias" class="dark-theme">crias</mat-icon><span>Crías</span></a>
                    </mat-list-item>
                    <mat-list-item class="dark-theme">
                        <a routerLink="/partes" (click)="toggleSideNav()" *mqIf="'(max-width: 640px)'" fxLayout="row"><mat-icon>list</mat-icon><span>Partes</span></a>
                        <a routerLink="/partes" (click)="hideSideNav()" *mqIf="'(min-width: 640px)'" fxLayout="row"><mat-icon>list</mat-icon><span>Partes</span></a>
                    </mat-list-item>
                    <mat-list-item class="dark-theme" *ngIf="accountHasModule(4) && user && user.level >= 7">
                        <a routerLink="/inseminaciones" (click)="toggleSideNav()" *mqIf="'(max-width: 640px)'" fxLayout="row"><mat-icon class="dark-theme">compare_arrows</mat-icon><span>Inseminaciones</span></a>
                        <a routerLink="/inseminaciones" (click)="hideSideNav()" *mqIf="'(min-width: 640px)'" fxLayout="row"><mat-icon class="dark-theme">compare_arrows</mat-icon><span>Inseminaciones</span></a>
                    </mat-list-item>
                    <mat-list-item class="dark-theme" *ngIf="accountHasModule(4)">
                        <a routerLink="/lactaciones" (click)="toggleSideNav()" *mqIf="'(max-width: 640px)'" fxLayout="row"><mat-icon svgIcon="milk-bottle" id="milk_icon" class="dark-theme"></mat-icon><span>Lactaciones</span></a>
                        <a routerLink="/lactaciones" (click)="hideSideNav()" *mqIf="'(min-width: 640px)'" fxLayout="row"><mat-icon svgIcon="milk-bottle" id="milk_icon" class="dark-theme"></mat-icon><span>Lactaciones</span></a>
                    </mat-list-item>
                    <mat-list-item class="dark-theme">
                        <a routerLink="/informes" (click)="toggleSideNav()" *mqIf="'(max-width: 640px)'" fxLayout="row"><mat-icon>list_alt</mat-icon><span>Informes</span></a>
                        <a routerLink="/informes" (click)="hideSideNav()" *mqIf="'(min-width: 640px)'" fxLayout="row"><mat-icon>list_alt</mat-icon><span>Informes</span></a>
                    </mat-list-item>
                    <!-- @if (user && user.level >= 7) { -->
                      <mat-list-item class="dark-theme">
                          <a routerLink="/imports" (click)="toggleSideNav()" *mqIf="'(max-width: 640px)'" fxLayout="row"><mat-icon>import_export</mat-icon><span>Importaciones</span></a>
                          <a routerLink="/imports" (click)="hideSideNav()" *mqIf="'(min-width: 640px)'" fxLayout="row"><mat-icon>import_export</mat-icon><span>Importaciones</span></a>
                      </mat-list-item>
                    <!-- } -->
                    <mat-list-item class="dark-theme">
                        <a routerLink="/libros" (click)="toggleSideNav()" *mqIf="'(max-width: 640px)'" fxLayout="row"><mat-icon>collections_bookmark</mat-icon><span>Libros</span></a>
                        <a routerLink="/libros" (click)="hideSideNav()" *mqIf="'(min-width: 640px)'" fxLayout="row"><mat-icon>collections_bookmark</mat-icon><span>Libros</span></a>
                    </mat-list-item>
                    <mat-list-item class="dark-theme" *ngIf="accountHasModule(2) && user && user.level >= 7">
                      <a routerLink="/scales" (click)="toggleSideNav()" *mqIf="'(max-width: 640px)'" fxLayout="row"><mat-icon>get_app</mat-icon><span>Básculas</span></a>
                      <a routerLink="/scales" (click)="hideSideNav()" *mqIf="'(min-width: 640px)'" fxLayout="row"><mat-icon>get_app</mat-icon><span>Básculas</span></a>
                    </mat-list-item>
                    <mat-list-item class="dark-theme" *ngIf="accountHasModule(7)">
                        <a routerLink="/valoracion-genetica" (click)="toggleSideNav()" *mqIf="'(max-width: 640px)'" fxLayout="row"><mat-icon>polymer</mat-icon><span>Valoración genética</span></a>
                        <a routerLink="/valoracion-genetica" (click)="hideSideNav()" *mqIf="'(min-width: 640px)'" fxLayout="row"><mat-icon>polymer</mat-icon><span>Valoración genética</span></a>
                    </mat-list-item>
                    <mat-list-item class="dark-theme">
                        <a routerLink="/pending" (click)="toggleSideNav()" *mqIf="'(max-width: 640px)'" fxLayout="row"><mat-icon>assignment_late</mat-icon><span>Pendientes</span></a>
                        <a routerLink="/pending" (click)="hideSideNav()" *mqIf="'(min-width: 640px)'" fxLayout="row"><mat-icon>assignment_late</mat-icon><span>Pendientes</span></a>
                    </mat-list-item>
                    @if (user && user.level >= 7) {
                      <mat-list-item class="dark-theme">
                          <a routerLink="/ganaderias" (click)="toggleSideNav()" *mqIf="'(max-width: 640px)'" fxLayout="row"><mat-icon>contacts</mat-icon><span>Socios</span></a>
                          <a routerLink="/ganaderias" (click)="hideSideNav()" *mqIf="'(min-width: 640px)'" fxLayout="row"><mat-icon>contacts</mat-icon><span>Socios</span></a>
                      </mat-list-item>
                    } @else if (user) {
                      <mat-list-item class="dark-theme">
                          <a [routerLink]="'/socios/' + user.idsocio" (click)="toggleSideNav()" *mqIf="'(max-width: 640px)'" fxLayout="row"><mat-icon>contacts</mat-icon><span>Datos del socio</span></a>
                          <a [routerLink]="'/socios/' + user.idsocio" (click)="hideSideNav()" *mqIf="'(min-width: 640px)'" fxLayout="row"><mat-icon>contacts</mat-icon><span>Datos del socio</span></a>
                      </mat-list-item>
                    }
                    <!-- <mat-list-item class="dark-theme">
                        <a routerLink="/cea" fxLayout="row"><mat-icon>library_books</mat-icon><span>CEAS</span></a>
                    </mat-list-item>
                    <div>
                        <mat-list class="dark-theme">
                            <div class="cnt-mat-list-item" *ngFor="let farm of dashboardData.partnerData.farms">
                                <mat-list-item class="dark-theme">
                                    <a [routerLink]="['/cea', farm]" fxLayout="row"><mat-icon></mat-icon><span>{{farm}}</span></a>
                                </mat-list-item>
                            </div>
                        </mat-list>
                    </div> -->
                </mat-list>
                <div fxFlex></div>
                <div>
                  <div class="version">v{{appService.version}}</div>
                </div>
            </div>
        </div>
    </div>
    <div fxFlex class="flex-column">
        <mat-toolbar color="primary" id="maintoolbar" fxLayout="row" style="background: #ef6c00;">

            <!-- <button id="mob-menu" mat-icon-button (click)="toggleSideNav()"><mat-icon>menu</mat-icon></button> -->
            <button id="mob-menu" *mqIf="'(max-width: 640px)'" mat-icon-button (click)="toggleSideNav()" fxHide.gt-sm><mat-icon>menu</mat-icon></button>
            <span *mqIf="'(max-width: 640px)'" style="margin-left: 12px;" class="flex-row flex-row-v-align-center"><span class="title-sm">SG</span> {{appService.appTitleSm}}</span>
            <span *mqIf="'(min-width: 640px)'" style="margin-left: 12px;">{{appService.appTitle}}</span>
            <span class="example-spacer flex-auto"></span>
            @if (auth.user.level >= 7) {
              <div *mqIf="'(min-width: 640px)'" class="cea flex-row flex-row-v-align-center">
                <label style="font-size: 11pt; font-weight: 100;"><span *ngIf="!selectedCEAObj || !selectedCEAObj.name">CEA &nbsp;</span><span class="farm-name" *ngIf="selectedCEAObj && selectedCEAObj.name">{{selectedCEAObj.name}} &nbsp;</span></label>
                <mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"class="cea-auto">
                    <input type="text" matInput [matAutocomplete]="autoCEA" [formControl]="ceaControl">
                    <button *ngIf="selectedCEA" matSuffix mat-icon-button aria-label="Clear" (click)="clearSelectedCEA()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-autocomplete #autoCEA="matAutocomplete">
                  <mat-option *ngFor="let farm of filteredCeas | async" [value]="farm" (onSelectionChange)="onSelectCEA($event)">
                    {{farm}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            }
            <button mat-icon-button aria-label="edit dashboard" [matMenuTriggerFor]="settingsMenu">
              <mat-icon>settings</mat-icon>
            </button>
            <mat-menu #settingsMenu="matMenu">
              <button [routerLink]="'/docs'" *ngIf="user && user.user == 'debug'" mat-menu-item> Docs </button>
              <button *mqIf="'(max-width: 640px)'" mat-menu-item (click)="selectCEA()"> Seleccionar CEA </button>
              <button mat-menu-item (click)="editDashboard()" *ngIf="showDashboardSettings()"> Editar dashboard </button>
              <button mat-menu-item [matMenuTriggerFor]="widgetsMenu" *ngIf="showDashboardSettings()"> Widgets </button>
              <button mat-menu-item (click)="toggleDarkTheme()"> {{themeButtonText}} </button>
              <button mat-menu-item (click)="newBugReport()"> Informar de un error </button>
              <button mat-menu-item (click)="userLogs()"> Registro de accesos </button>
            </mat-menu>
            <mat-menu #widgetsMenu="matMenu">
                <button *ngFor="let widget of appService.widgets" mat-menu-item (click)="appService.addWidget(widget)"> {{widget.name}} </button>
            </mat-menu>
            <twa-md2-notifications [notifsService]="notifsSvc" (panelClicked)="panelClicked($event)" (panelClosed)="panelClosed($event)"></twa-md2-notifications>
            <button mat-icon-button aria-label="logout" (click)="logout()">
                <mat-icon>logout</mat-icon>
            </button>

        </mat-toolbar>

        <mat-menu #appMenu="matMenu">
            <button mat-menu-item> Settings </button>
            <button mat-menu-item> Help </button>
        </mat-menu>
        <router-outlet style="position: absolute; height: calc(100% - 80px);"></router-outlet>
        <app-ai-assistant *ngIf="isUserLoggedIn && isAiEnabled" [selectedCEA]="selectedCEA" [themeClass]="themeClass"></app-ai-assistant>
    </div>
</div>
